import styled from 'styled-components';
export const SpinnerContainer = styled.div `
  display: grid;
  width: 1.5rem;
  height: 1.5rem;
  gap: 0.25rem;
  padding: 2px;
  box-sizing: border-box;
`;
